import { useTranslate, type Identifier } from "ra-core";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import { getSaleName, useActiveSales } from "./useActiveSales";

export interface AssigneeSelectProps {
  value: Identifier | null | undefined;
  onChange: (salesId: Identifier) => void;
  className?: string;
  label?: string;
}

export const AssigneeSelect = ({
  value,
  onChange,
  className,
  label,
}: AssigneeSelectProps) => {
  const translate = useTranslate();
  const sales = useActiveSales();
  return (
    <Select
      value={value != null ? String(value) : ""}
      onValueChange={(next) => {
        const sale = sales.find((candidate) => String(candidate.id) === next);
        if (sale) onChange(sale.id);
      }}
    >
      <SelectTrigger
        className={className}
        aria-label={label ?? translate("crm.operations.fields.assignee")}
      >
        <SelectValue placeholder={translate("crm.operations.combobox.none")} />
      </SelectTrigger>
      <SelectContent>
        {sales.map((sale) => (
          <SelectItem key={sale.id} value={String(sale.id)}>
            {getSaleName(sale)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
